import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
    createStyles({
        pane: {
            display: 'flex',
            position: 'relative',
            height: '100%',
            width: '100%',
            zIndex: 13,
        },
        wrapper: {
            display: 'flex',
            position: 'relative',
            flexGrow: 1,
            flexDirection: 'column',
        },
    })
);
